
import React, { createContext, useContext, useState } from 'react';
import { Player, CourtResult } from '@/types/tournament';
import { toast } from 'sonner';
import { useLanguage } from '@/contexts/LanguageContext';
import { 
  TournamentContextType, 
  ExtendedTournamentState, 
  defaultTournamentState 
} from './tournament/types';
import { 
  createStartTournament,
  createSubmitRoundResults,
  createFinishAmericanoRound,
  createGoToPreviousRound
} from './tournament/tournamentActions';

const TournamentContext = createContext<TournamentContextType | null>(null);

export function TournamentProvider({ children }: { children: React.ReactNode }) {
  const [tournamentState, setTournamentState] = useState<ExtendedTournamentState>(defaultTournamentState);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const { t, language } = useLanguage();

  const setTournamentType = (type: 'mexicano' | 'americano' | 'team_americano' | null) => {
    console.log('Setting tournament type:', type);
    setTournamentState(prev => ({
      ...prev,
      tournamentType: type
    }));
  };
  
  const startTournament = createStartTournament(setTournamentState, setShowLeaderboard, language, t);
  const submitRoundResults = createSubmitRoundResults(setTournamentState, t);
  const finishAmericanoRound = createFinishAmericanoRound(setTournamentState, language);
  const goToPreviousRound = createGoToPreviousRound(setTournamentState, language);
  
  // Reset the tournament
  const resetTournament = () => {
    console.log('Resetting tournament');
    setTournamentState(defaultTournamentState);
    setShowLeaderboard(false);
    toast.info(t("tournament.mexicano.reset"));
  };

  const contextValue: TournamentContextType = {
    tournamentState, 
    startTournament, 
    submitRoundResults, 
    resetTournament,
    showLeaderboard,
    setShowLeaderboard,
    finishAmericanoRound,
    setTournamentType,
    goToPreviousRound
  };
  
  return (
    <TournamentContext.Provider value={contextValue}>
      {children}
    </TournamentContext.Provider>
  );
}

export function useTournament() {
  const context = useContext(TournamentContext);
  if (!context) {
    console.error('useTournament called outside of TournamentProvider');
    throw new Error("useTournament must be used within a TournamentProvider");
  }
  return context;
}
